import { TranslateSitePayload } from "@app/_models/pages/page.model";

export class SettingsAction {
    public static readonly type = '[Settings] Add item';
    constructor(public payload: string) {}
}
export class SetSettingsNav {
    public static readonly type = '[Settings] SetSettingsNav';
    constructor(public isOwnwer: boolean) {}
}

export class SettingsExecuteSubmit {
    public static readonly type = '[Design] SettingsExecuteSubmit';
    constructor(public execute: boolean) {}
}

export class TranslateSite {
    public static readonly type = '[Design] TranslateSite';
    constructor(public payload: TranslateSitePayload) {}
}
